import React from 'react'
import './NewsHeader.css';
import SearchRoundedIcon  from '@material-ui/icons/SearchRounded';

function NewsHeader({newsName}) {
    return (
        <div className="newsHeader">
            <h3></h3>
            <div className="newsHeader__left">
                <h3>
                    <span className="newsHeader__hash">
                        #
                    </span>
                    {newsName}
                </h3>
            </div>
            <div className="newsHeader__right">
                <div className="newsHeader__search">
                    <input placeholder="Search"/> 
                    <SearchRoundedIcon/>
                </div>
            </div>
        </div>
    )
}

export default NewsHeader
